<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-card>
        <b-row>
          <b-col>
            <h4>{{ $t('nav.ai_jobs_list_title') }}</h4>
          </b-col>
          <b-col md="auto">
            <b-button-group>
              <b-button v-if="!loading && list.actions && list.actions.create" class="mb-3" variant="primary" :to="{ name: 'AiJobCreate' }">
                {{ $t('ai_job.create_new') }}
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group>
              <b-input-group>
                <b-form-input :placeholder="$t('global.search')" v-model="filters.search"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary" @click="getData()"><i class="fa fa-search"/></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col md="auto" >
            <b-form-group label-cols :label="$dt('global.per_page', 'Per page:')">
                <b-form-select :options="[2,10,20,50,100,500]" v-model="filters.per_page" />
            </b-form-group>
          </b-col>
          <b-col md="auto" v-if="listPaginator.last_page > 1" >
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
          </b-col>
        </b-row>
        <div v-if="loading" class="text-center">
          <b-spinner type="grow" variant="primary"/>
        </div>
        <div v-else>
          <b-row>
            <b-col>
              <NoDataView v-if="!tableItems.length"/>
              <b-table v-else class="table-sm text-center" responsive outlined hover head-variant="light"
                  :no-local-sorting=true
                  :sort-by.sync="filters.sort_field"
                  :sort-desc.sync="filters.sort_order"
                  :fields="tableFields"
                  :items="tableItems"
                  >
                <template v-slot:cell(ai_job_units_count)="row">
                    <b-badge class="mx-1" variant="warning"  v-if="row.item.ai_job_units_processing">{{$dt('ai_jobs.statuses.in_progress', 'In progress')}}: {{row.item.ai_job_units_processing}}</b-badge>
                    <b-badge class="mx-1" variant="danger"  v-if="row.item.ai_job_units_error">{{$dt('ai_jobs.statuses.errors', 'Errors')}}: {{row.item.ai_job_units_error}}</b-badge>
                    <b-badge class="mx-1">{{row.item.ai_job_units_done}} / {{row.item.ai_job_units_count}}</b-badge>
                </template>
                <template v-slot:cell(options)="row">
                  <div class="flex-container options-center">
                  <router-link v-if="row.item.actions.update" :to="{ name: 'AiJobUpdate', params:{ project_id: row.item.project_id, id: row.item.id }}">
                    <a><i class="mx-1 fa fa-edit fa-lg"/></a>
                  </router-link>
                  <Delete v-if="row.item.actions.delete"  :id="row.item.id" @deleted="getData" :deleteFn="()=>deleteFn(row.item.project_id, row.item.id)" />
                  </div>
                </template>
              </b-table>
            </b-col>
          </b-row>
          <b-row>
            <!--Paginator at bottom-->
            <b-col v-if="tableItems.length">
              <Pagination :data="listPaginator" :limit="5" @pagination-change-page="onPageChange"/>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import Pagination from 'laravel-vue-pagination';
import NoDataView from '@/views/Shared/NoDataView.vue';
import Delete from '@/views/Shared/ModalDelete';
import Services from '@/services/index';
import { mapGetters, mapActions, mapState } from 'vuex';

export default {
  mounted() {
    this.getData();
  },
  props: ['page'],
  data() {
    return {
      tableFields: [
        { key: 'id', sortable: true, label: this.$t('global.id') },
        { key: 'name', sortable: true, label: this.$t('ai_job.name') },
        { key: 'ai_job_units_count', sortable: true, label: this.$dt('ai_job.ai_job_units_count', 'Remaining jobs') },
        { key: 'created_at', sortable: true, label: this.$t('global.created_at') },
        { key: 'updated_at', sortable: true, label: this.$t('global.updated_at') },
        { key: 'options', label: this.$t('global.options') }
      ],
      filters: {
        sort_field: 'id',
        sort_order: true,
        search: '',
        per_page: 20,
      },
      loading: false,
      list: {},
    };
  },
  components: {
    Pagination, NoDataView, Delete
  },
  computed: {
    listPaginator() {
      return Object.is(this.list.meta, undefined) ? {} : this.list.meta;
    },
    tableItems() {
      return this.list.data || [];
    },
    params() {
      return {
        ...this.filters,
        page: this.page,
        sort_order: this.filters.sort_order ? 'desc' : 'asc'
      };
    },
    ...mapState('Auth', ['activeProjectId']),
  },
  watch: {
    page: 'getData',
    filters: { deep: true, handler: 'getData' },
  },
  methods: {
    getData() {
      this.loading = true;
      Services.aiJobs.list(this.activeProjectId, this.params).then(({ data }) => {
        this.list = data;
        this.loading = false;
      }).catch((err) => { this.loading = false; console.log(err); });
    },
    onPageChange(page) {
      page = page || this.page;
      if (page !== this.page) this.$router.push({ name: 'AiJobs', params: { page } });
    },
    deleteFn(projectId, id) {
      return Services.aiJobs.delete(projectId, id);
    }
  }
};
</script>

<style scoped>
</style>
